import {createSlice} from "@reduxjs/toolkit";
import {catchError, exportDone, getError, initialState, itemCreated, itemDeleted, itemFetched, itemsFetched, itemUpdated, pdfDone, resetItemState, resetPdfState, saveDone, startCall, STATE_ERROR, STATE_FETCHED, STATE_FETCHING, STATE_INITIAL} from "../../../../../_intesys/_helpers";

const initialFolderSignatureTypesState = {
    state: STATE_INITIAL,
    error: null,
    data: undefined,
};


export const foldersSlice = createSlice({
    name: "folders",
    initialState: {
        ...initialState,

        folderSignatureTypes: {},
    },
    reducers: {
        resetItemState: resetItemState,
        saveDone: saveDone,
        catchError: catchError,
        startCall: startCall,
        itemsFetched: itemsFetched,
        itemFetched: itemFetched,
        itemCreated: itemCreated,
        itemUpdated: itemUpdated,
        itemDeleted: itemDeleted,
        exportDone: exportDone,
        pdfDone: pdfDone,
        resetPdfState: resetPdfState,

        getFolderSignatureTypesStart: (state, action) => {
            const {key} = action.payload;
            if (state.folderSignatureTypes[key] === undefined) {
                state.folderSignatureTypes[key] = {...initialFolderSignatureTypesState};
            }
            state.folderSignatureTypes[key].state = STATE_FETCHING;
        },
        getFolderSignatureTypesDone: (state, action) => {
            const {key} = action.payload;

            state.folderSignatureTypes[key].state = STATE_FETCHED;
            state.folderSignatureTypes[key].data = action.payload.data;
            state.folderSignatureTypes[key].error = null;
        },
        getFolderSignatureTypesError: (state, action) => {
            const error = getError(action);
            const {key} = action.payload;

            state.folderSignatureTypes[key].state = STATE_ERROR;
            state.folderSignatureTypes[key].data = undefined;
            state.folderSignatureTypes[key].error = error;
        }
    }
});
